// @flow
import styled, { css } from 'styled-components';
import { screen } from '../lib/utils';

export const buttonReset = css`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  appearance: none;
  text-align: inherit;
  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  /* Remove excess padding and border in Firefox 4+ */
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;

export const darkStyles = css`
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.black};
`;

export const lightStyles = css`
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const buttonCSS = css`
  font-weight: bold;
  cursor: pointer;
  padding: calc(1.5rem - 3px) calc(3rem - 3px) calc(1.5rem - 5px);
  font-size: 1.25rem;
  text-transform: uppercase;
  user-select: none;
  letter-spacing: 0.05em;
  border: 3px solid ${({ theme }) => theme.colors.black};
  transition: all ${({ theme }) => theme.animation.fast};
`;

const Button = styled.button`
  ${buttonReset}
  ${buttonCSS}
  display: inline-block;
  ${({ secondary }) => (secondary ? lightStyles : darkStyles)}

  & + & {
    margin-top: 1rem;

    ${screen.atLeast.tablet`
      margin-top: 0;
      margin-left: 1.5rem;
    `}
  }

  &:hover,
  &:disabled {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.darkGray};
    border-color: ${({ theme }) => theme.colors.darkGray};
  }

  &:disabled {
    opacity: .87;
  }

  &:focus {
    outline: 0;
    /* box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.gray}; */
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.darkGray};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  margin-bottom: 50px;

  ${Button} {
    width: 100%;
    text-align: center;
    padding: calc(1.5rem - 3px) calc(2rem - 3px);

    ${screen.atLeast.tablet`
      flex: 0 1 ${({ buttonWidth }) => buttonWidth || 'auto'};
    `}
  }

  ${screen.smallerThan.tablet`
    flex-direction: column;
  `}
`;

export default Button;
